import { mapActions } from "vuex";
export default {
  data: () => ({
    employeeId: ""
  }),
  computed: {},
  methods: {
    ...mapActions("user", ["callForgotPass"]),
    notifyVue(type = "default", message) {
      this.$notify({
        message,
        timeout: 3000,
        icon: "ni ni-bell-55",
        type
      });
    },
    async sendForgotPass() {
      try {
        const otpId = Number(this.$route.params.id);
        if (otpId) {
          await this.callForgotPass({
            employeeId: this.employeeId,
            isOTP: 1
          });
          this.notifyVue(
            "success",
            "Request success, silahkan login dengan kode OTP yang dikirim di email"
          );
          this.$router.push({ name: "LoginOTP", params: { otp: "otp" } });
        } else {
          await this.callForgotPass({
            employeeId: this.employeeId
          });
          this.notifyVue(
            "success",
            "Request success, your temporary password will be sent to your whatsApp later"
          );
          this.$router.push("/auth/login");
        }
      } catch (err) {
        this.notifyVue("danger", err.response.data.error);
      }
    }
  },
  mounted() {
  }
};
